var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 10 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0986 7.79965L12.5001 2.20115C12.366 2.06705 12.1983 2 11.9972 2C11.7961 2 11.6284 2.06705 11.4943 2.20115L5.92936 7.79965C5.70587 7.97844 5.61647 8.21311 5.66117 8.50365C5.72822 8.79419 5.90701 8.97298 6.19755 9.04003C6.48809 9.10708 6.72276 9.02886 6.90155 8.80536L11.2932 4.3802V21.296C11.2932 21.4971 11.3602 21.6648 11.4943 21.7989C11.6284 21.933 11.7961 22 11.9972 22C12.1983 22 12.366 21.933 12.5001 21.7989C12.6342 21.6648 12.7012 21.4971 12.7012 21.296V4.3802L17.0928 8.80536C17.2269 8.93946 17.3946 9.00651 17.5957 9.00651C17.7968 9.00651 17.9645 8.93946 18.0986 8.80536C18.2327 8.67127 18.2997 8.50365 18.2997 8.3025C18.2997 8.10136 18.2327 7.93374 18.0986 7.79965Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/Arrow up.35c6dff4c0648c1a8ffd88f8dd68d90a.svg";
export { ForwardRef as ReactComponent };